import CustomCalendar from '@/components/common/Custom/CustomCalendar/CustomCalendar';
import CustomModalOverlay from '@/components/common/Custom/CustomModalOverlay/CustomModalOverlay';
import GlobalButton from '../../ui/GlobalButton';
import dayjs from 'dayjs';

// Separated Modal Component
interface TimelineModalProps {
  isOpen: any;
  onClose: any;
  localStartDate: any;
  localEndDate: any;
  onStartDateChange: (date: any) => void;
  onEndDateChange: (date: any) => void;
  onSave: () => void;
}

export default function TimelineModal({
  isOpen,
  onClose,
  localStartDate,
  localEndDate,
  onStartDateChange,
  onEndDateChange,
  onSave,
}: TimelineModalProps) {
  const today = dayjs().startOf('day');

  return (
    <CustomModalOverlay width="fit-content" open={isOpen} onClose={onClose}>
      <div className="rounded-xl w-full p-2">
        <div className="flex items-start gap-2 mb-4">
          <Clock />
          <div>
            <h2 className="text-xl font-bold text-text-primary-heading">
              Add Project Timeline
            </h2>
            <p className="text-text-primary-body max-w-md">
              Define key milestones and deadlines to help Crafter structure your
              project roadmap.
            </p>
          </div>
        </div>

        <div className="flex items-stretch gap-4 mb-6 w-full">
          {/* Calendars */}
          <div className="flex border border-frame-stroke rounded-lg p-2 gap-2 divide-x divide-frame-stroke">
            <div className="pr-2">
              <CustomCalendar
                label="Start Date"
                selectedDate={localStartDate}
                onSelectDate={onStartDateChange}
                minDate={today}
              />
            </div>
            <div className="pl-2">
              <CustomCalendar
                label="End Date"
                selectedDate={localEndDate}
                onSelectDate={onEndDateChange}
                minDate={localStartDate}
              />
            </div>
          </div>

          {/* Preview */}
          <div className="flex-1 min-w-[220px] p-4 border border-frame-stroke bg-modal-input rounded-lg h-fit">
            <p className="text-sm mb-1">Start Date</p>
            <div className="p-4 bg-transparent border border-frame-stroke rounded">
              {localStartDate.format('DD MMMM, YYYY')}
            </div>
            <p className="text-sm mt-3 mb-1">End Date</p>
            <div className="p-4 bg-transparent border border-frame-stroke rounded">
              {localEndDate.format('DD MMMM, YYYY')}
            </div>
          </div>
        </div>

        <div className="flex justify-end gap-3">
          <div>
          <GlobalButton
            onClick={onClose}
            variant="stroke"
            size="md"
            state="default"
          >
            Cancel
          </GlobalButton>
          </div>
          <div>
          <GlobalButton
            onClick={onSave}
            variant="purple"
            size="md"
            state="default"
          >
            Save Timeline
          </GlobalButton>
          </div>
        </div>
      </div>
    </CustomModalOverlay>
  );
}

function Clock() {
  return (
    <svg
      width="35"
      height="35"
      viewBox="0 0 35 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.5 1.35449C26.4171 1.35449 33.6455 8.5829 33.6455 17.5C33.6455 26.4171 26.4171 33.6455 17.5 33.6455C8.5829 33.6455 1.35449 26.4171 1.35449 17.5C1.35449 8.5829 8.5829 1.35449 17.5 1.35449Z"
        stroke="#3E3E3E"
        stroke-width="1.29167"
      />
      <path
        d="M20.695 20.2383L18.0255 18.6452C17.5605 18.3697 17.1816 17.7066 17.1816 17.1641V13.6335"
        stroke="#7A7A7A"
        stroke-width="1.9375"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.6109 12.3334C9.53451 13.7714 8.88867 15.5625 8.88867 17.5C8.88867 22.2534 12.7464 26.1111 17.4998 26.1111C22.2531 26.1111 26.1109 22.2534 26.1109 17.5C26.1109 12.7467 22.2531 8.88892 17.4998 8.88892C16.2684 8.88892 15.0887 9.14725 14.0295 9.62086"
        stroke="#7A7A7A"
        stroke-width="1.9375"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
